package ru.it_mozaika.components

import mui.material.*
import mui.system.sx
import org.w3c.dom.events.KeyboardEvent
import react.*
import react.dom.aria.ariaLabel
import web.cssom.px

external interface SearchFieldProps: Props {
    var onSearchQueryChange: (String) -> Unit
    var placeHolder: String?
}
val searchField = FC<SearchFieldProps> { props ->

    var query by useState("")
    useEffect(query) {
        props.onSearchQueryChange(query)
    }

    FormControl {
        sx {
            minWidth = 300.px
        }
//        fullWidth = true
        variant = FormControlVariant.outlined
        color = FormControlColor.secondary
        OutlinedInput {
            placeholder = props.placeHolder ?: ""
            color = InputBaseColor.secondary
            id = "search-filed"
            onChange = { event ->
                val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                query = newValue.lowercase()
            }
            endAdornment = InputAdornment.create {
                ariaLabel = ""
                this.position = InputAdornmentPosition.end
                mui.icons.material.SearchSharp {
                    color = SvgIconColor.secondary
                    onClick = {
                        props.onSearchQueryChange(query)
                    }
                }
                onMouseDown = {
                    it.preventDefault()
                }
            }
            onKeyDown = {
                val event = it.unsafeCast<KeyboardEvent>()
                when (event.key.lowercase()) {
                    "backspace",
                    "enter" -> props.onSearchQueryChange(query)
                }
            }
        }
    }
}